import React from "react";
import PropTypes from "prop-types";
import i18n from "i18next";
import { LuX } from "react-icons/lu";
import LogoIntroTab from "../../../logo_intro/LogoIntroTab";
import "./_panel.scss";

/**
 * Left rail → "Logo Intro": the logo intro builder in the side panel. Adding
 * the intro inserts it as the first scene and closes the panel.
 */
const LogoIntroPanel = ({ onClose }) => (
  <div className="cmp-panel logo-intro-panel">
    <div className="cmp-panel__toolbar">
      <span className="cmp-panel__title">{i18n.t("logo_intro_panel")}</span>
      {onClose && (
        <button
          type="button"
          className="cmp-panel__close"
          onClick={onClose}
          title={i18n.t("close") || "Kapat"}
        >
          <LuX size={15} />
        </button>
      )}
    </div>
    <div className="cmp-panel__scroll">
      <LogoIntroTab onAdded={onClose} />
    </div>
  </div>
);

LogoIntroPanel.propTypes = {
  onClose: PropTypes.func,
};

export default LogoIntroPanel;
